<script setup lang="ts">
import { computed } from "vue";
import type { DashboardSummaryStat } from "../../features/dashboard/dashboard.types.ts";
import { useDashboardTheme } from "../../features/dashboard/useDashboardTheme.ts";

const props = defineProps<{
  stat: DashboardSummaryStat;
}>();

const { theme } = useDashboardTheme();

const iconStyle = computed(() => ({
  color: props.stat.accentColor,
  backgroundColor: toRgba(
    props.stat.accentColor,
    theme.value === "light" ? 0.14 : 0.12
  ),
}));

function toRgba(color: string, alpha: number): string {
  const normalized = color.replace("#", "");
  const expanded =
    normalized.length === 3
      ? normalized.replaceAll(/(.)/g, "$1$1")
      : normalized;

  const r = Number.parseInt(expanded.slice(0, 2), 16);
  const g = Number.parseInt(expanded.slice(2, 4), 16);
  const b = Number.parseInt(expanded.slice(4, 6), 16);

  return `rgba(${String(r)}, ${String(g)}, ${String(b)}, ${String(alpha)})`;
}
</script>

<template>
  <article class="dashboard-card rounded-2xl px-5 py-4">
    <div class="flex items-start justify-between gap-3">
      <span
        class="inline-flex h-10 w-10 items-center justify-center rounded-xl text-lg font-semibold"
        :style="iconStyle"
      >
        {{ props.stat.icon }}
      </span>
      <p
        class="dashboard-text-secondary max-w-[12rem] text-right text-xs font-semibold tracking-[0.14em] uppercase"
      >
        {{ props.stat.label }}
      </p>
    </div>
    <p
      class="dashboard-text-primary mt-5 text-[2.35rem] leading-none font-semibold"
    >
      {{ props.stat.value }}
    </p>
    <p class="dashboard-text-secondary mt-3 text-sm">{{ props.stat.detail }}</p>
  </article>
</template>
